import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UmbracoService {
  private UMBRACO_API_ENDPOINT: string = '/content/umbraco/api';

  constructor(private http: HttpClient) {

  }


  postUmbracoDataWithParent(documentTypeAlias: string, parentName: string, propertyAliasList: string[], operation: string) {

    const input = {
      'DocumentTypeAlias': documentTypeAlias,
      'ParentName': parentName,
      'PropertyAliasList': propertyAliasList,
      'WebsiteName': 'Minsak'
    };

    return this.http.post<any[]>(this.UMBRACO_API_ENDPOINT + operation, input)
      .pipe(
        map(
          (data: any[]) => {
            return data.map(
              (item: any) => {
                if (item.Properties) {
                  item.Properties.forEach(
                    (prop: any) => {
                      item[prop.Alias] = prop.Value;
                    }
                  );
                }
                return item;
              }
            );
          }
        )
      );
  }

  postUmbracoData(documentTypeAlias: string, propertyAliasList: string[], operation: string) {

    const input = {
      'DocumentTypeAlias': documentTypeAlias,
      'PropertyAliasList': propertyAliasList,
      'WebsiteName': 'Minsak'
    };

    return this.http.post<any[]>(this.UMBRACO_API_ENDPOINT + operation, input)
      .pipe(
        map(
          (data: any[]) => {
            return data.map(
              (item: any) => {
                if (item.Properties) {
                  item.Properties.forEach(
                    (prop: any) => {
                      item[prop.Alias] = prop.Value;
                    }
                  );
                }
                return item;
              }
            );
          }
        )
      );
  }

}
